<span class="notif-bell-wrapper" pTooltip="Notificaciones" tooltipPosition="bottom">
  <i
    *ngIf="count === 0"
    class="pi pi-bell text-white text-xl cursor-pointer hover:text-200 transition-colors"
    (click)="toggle($event)"
  ></i>
  <i
    *ngIf="count > 0"
    class="pi pi-bell text-white text-xl cursor-pointer hover:text-200 transition-colors"
    pBadge
    [value]="count > 99 ? '99+' : '' + count"
    severity="danger"
    (click)="toggle($event)"
  ></i>
</span>

<p-overlayPanel
  #op
  [style]="{ width: '22rem' }"
  [showCloseIcon]="false"
  appendTo="body"
  (onShow)="onShow()"
>
  <div class="notif-panel">
    <!-- Header -->
    <div class="notif-panel__header">
      <span class="font-semibold">Notificaciones</span>
      <button
        *ngIf="count > 0"
        pButton
        type="button"
        label="Marcar todas leídas"
        class="p-button-text p-button-sm p-button-plain"
        icon="pi pi-check-circle"
        (click)="marcarTodasLeidas()"
      ></button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="notif-panel__loading">
      <p-skeleton *ngFor="let _ of [1,2,3]" height="3.5rem" styleClass="mb-2"></p-skeleton>
    </div>

    <!-- Lista -->
    <div *ngIf="!loading" class="notif-panel__list">
      <div
        *ngFor="let item of items; trackBy: trackById"
        class="notif-item"
        [class.notif-item--unread]="!item.leida"
        [class.notif-item--clickable]="!!item.enlace"
        (click)="navegar(item)"
      >
        <div class="notif-item__dot" *ngIf="!item.leida"></div>

        <div class="notif-item__body">
          <div class="notif-item__title">{{ item.titulo }}</div>
          <div class="notif-item__msg" *ngIf="item.mensaje">{{ item.mensaje }}</div>
          <div class="notif-item__time">{{ item.fechaCreacion | date:'dd/MM/yy HH:mm' }}</div>
        </div>

        <div class="notif-item__actions">
          <button
            *ngIf="!item.leida"
            pButton
            type="button"
            icon="pi pi-check"
            class="p-button-rounded p-button-text p-button-sm"
            pTooltip="Marcar leída"
            tooltipPosition="left"
            (click)="marcarLeida(item); $event.stopPropagation()"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-rounded p-button-text p-button-sm p-button-danger"
            pTooltip="Descartar"
            tooltipPosition="left"
            (click)="eliminar(item, $event)"
          ></button>
        </div>
      </div>

      <!-- Empty -->
      <div *ngIf="items.length === 0" class="notif-panel__empty">
        <i class="pi pi-bell-slash text-400 text-3xl mb-2"></i>
        <p class="text-500 text-sm">Sin notificaciones</p>
      </div>
    </div>

    <!-- Footer: Ver todas -->
    <div class="notif-panel__footer">
      <button
        pButton
        type="button"
        label="Ver todas"
        icon="pi pi-list"
        class="p-button-text p-button-sm p-button-plain w-full"
        (click)="verTodas()"
      ></button>
    </div>
  </div>
</p-overlayPanel>
